import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style.pcss';

export default class Select extends Component { //eslint-disable-line react/prefer-stateless-function

    static displayName = '[block] button';

    static propTypes = {
        children : PropTypes.string,
        className: PropTypes.string,
        onClick  : PropTypes.func
    };

    render() {
        return (
            <div onClick={this.props.onClick} className={`${style['button']} ${this.props.className}`}>
                {this.props.children}
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/blocks/button/index.js